export const TEMPERATURAKKTPROIZVODI_V1ResourcesEN: TEMPERATURAKKTPROIZVODI_V1ResourcesBSInterface =
  {
    labelDone: "Task completion date",
    errorMissingInput: "Please fill in all fields",
    input: {
      signatureTitle: "Signature",
      checkbox: {
        label:
          "I confirm that I have been notified that the temperature is not appropriate",
        name: "checkbox",
        placeholder: "You must accept this field",
      },
      proizvod: {
        label: "Product",
        placeholder: "Please enter product name",
        name: "proizvod",
        error: "Product name is not entered",
      },

      datum: {
        label: "Please enter date",
        placeholder: "Please enter date",
        name: "datum",
      },
      ocitanaTemperatura: {
        label: "Read temperature",
        name: "ocitanaTemperatura",
        placeholder: "Please enter read temperature",
      },
      napomena: {
        label: "Note",
        name: "napomena",
        placeholder: "Please enter note",
      },
      korektivnaMjera: {
        label: "Corrective Measure",
        name: "korektivnaMjera",
        placeholder: "Please select if corrective measure is needed",
      },
    },
    evidencijaForm: {
      buttonForward: "Sign",
      buttonBack: "Back",
    },
    successModal: {
      title: "Data Entry",
      body: "Data addition has been successfully completed. Select OK to continue.",
      buttonOk: "OK",
    },
    txtPotvrda:
      "By selecting the Sign option, I confirm that the task has been performed according to the instructions!",
    dropdownKorektivnaMjera: {
      da: "Yes",
      ne: "No",
      undefined: "Please select field",
    },
  };

interface InputField {
  label: string;
  name: string;
  placeholder?: string;
  error?: string;
}

interface Input {
  signatureTitle: string;
  datum: InputField;
  ocitanaTemperatura: InputField;
  napomena: InputField;
  checkbox: InputField;
  korektivnaMjera: InputField;
  proizvod: InputField;
}

interface EvidencijaForm {
  buttonForward: string;
  buttonBack: string;
}

interface SuccessModal {
  title: string;
  body: string;
  buttonOk: string;
}

interface IDropdownOptions {
  da: string;
  ne: string;
  undefined: string;
}

export interface TEMPERATURAKKTPROIZVODI_V1ResourcesBSInterface {
  labelDone: string;
  errorMissingInput: string;
  input: Input;
  evidencijaForm: EvidencijaForm;
  successModal: SuccessModal;
  txtPotvrda: string;
  dropdownKorektivnaMjera: IDropdownOptions;
}
